import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  private static ADMIN = 'ADMIN';
  private static SUPERADMIN = 'SUPERADMIN';
  private static USER = 'USER';
  // TODO!!!!!!!
  private KEY_JWTACCESSTOKEN = 'tacIs?F7#Xll!VTO?R9ATQm#i'; // environment.key_jwtaccesstoken;
  private KEY_JWTREFRESHTOKEN = 'pJf?V4?Gy!eKw#GO!qJgL3v73'; // environment.key_jwtrefreshtoken;
  private KEY_USER = 'aGHLMaG!xI?d#nGcOUhQz#2G'; // environment.key_user;
  private KEY_COMPANYID = 'qB7hJRF!h!h6C?cf#?b8IvXu0'; // environment.key_companyid;
  private KEY_ROLES = 'lzMn#gxaFuW?zMa!hZZpEi9?#'; // environment.key_roles;
  private KEY_EMAILNOTCONFIRMED = 'GB1?1nu!ZEAR9zph?!FB#VqvJ'; // environment.key_roles;
  private KEY_ACTIVITYDATE = 'A?qv?VR1nuBJzG1!ZFE#9p!hB';
  private KEY_USERPERMISSION = 'A?qv?VR1nuBJzG1!ZFE#9p!hA';

  private getV(k: string) {
    if (localStorage.getItem(k) != null) {
      return localStorage.getItem(k);
    } else {
      return null;
    }
  }

  private saveV(k: string, value) {
    localStorage.setItem(k, value);
  }

  private clearV(k: string) {
    localStorage.removeItem(k);
  }

  getAuthorizationToken() {
    return 'Bearer ' + this.getJWTaccesToken();
  }

  getJWTaccesToken() {
    return this.getV(this.KEY_JWTACCESSTOKEN);
  }

  saveJWTaccessToken(jwt: string) {
    this.saveV(this.KEY_JWTACCESSTOKEN, jwt);
  }

  clearJWTaccessToken() {
    this.clearV(this.KEY_JWTACCESSTOKEN);
  }

  getJWTrefreshToken() {
    return this.getV(this.KEY_JWTREFRESHTOKEN);
  }

  saveJWTrefreshToken(jwt: string) {
    this.saveV(this.KEY_JWTREFRESHTOKEN, jwt);
  }

  clearJWTrefreshToken() {
    this.clearV(this.KEY_JWTREFRESHTOKEN);
  }

  getUser() {
    return this.getV(this.KEY_USER);
  }

  saveUser(user: string) {
    this.saveV(this.KEY_USER, user);
  }

  clearUser() {
    this.clearV(this.KEY_USER);
  }

  getUserPermission() {
    return this.getV(this.KEY_USERPERMISSION);
  }

  saveUserPermission(userPermission: any) {
    const userPermissionsStringigy = JSON.stringify(userPermission);
    this.saveV(this.KEY_USERPERMISSION, userPermissionsStringigy);
  }

  clearUserPermission() {
    this.clearV(this.KEY_USERPERMISSION);
  }

  saveEmailNotConfirmed() {
    this.saveV(this.KEY_EMAILNOTCONFIRMED, 'Not Confirmed');
  }

  getEmailNotConfirmed() {
    return this.getV(this.KEY_EMAILNOTCONFIRMED);
  }

  clearEmailNotConfirmed() {
    this.clearV(this.KEY_EMAILNOTCONFIRMED);
  }

  getCompanyId() {
    if (this.getV(this.KEY_COMPANYID) != null) {
      return parseInt(this.getV(this.KEY_COMPANYID));
    }
    return null;
  }

  saveCompanyId(companyId: number) {
    if (companyId) {
      this.saveV(this.KEY_COMPANYID, String(companyId));
    } else {
      this.clearCompanyId();
    }
  }

  clearCompanyId() {
    this.clearV(this.KEY_COMPANYID);
  }

  saveActivityDate(date: Date) {
    this.saveV(this.KEY_ACTIVITYDATE, date.toISOString());
  }

  getActivityDate() {
    const d = this.getV(this.KEY_ACTIVITYDATE);
    let result = null;
    if (d) {
      result = new Date(d);
    }
    return result;
  }

  clearActivityDate() {
    this.clearV(this.KEY_ACTIVITYDATE);
  }

  getRoles(): string[] {
    if (this.getV(this.KEY_ROLES) != null) {
      return JSON.parse(this.getV(this.KEY_ROLES));
    }
    return [];
  }

  saveRoles(roles: string[]) {
    if (roles) {
      this.saveV(this.KEY_ROLES, JSON.stringify(roles));
    } else {
      this.clearRoles();
    }
  }

  clearRoles() {
    this.clearV(this.KEY_ROLES);
  }

  getIsAdmin() {
    return this.getRoles().findIndex(x => x === StorageService.ADMIN) !== -1;
  }

  getIsSuperadmin() {
    return this.getRoles().findIndex(x => x === StorageService.SUPERADMIN) !== -1;
  }

  getIsUser() {
    return this.getRoles().findIndex(x => x === StorageService.USER) !== -1;
  }
}
